import React, { useEffect, useState, useContext } from 'react';
import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import useDictionary from 'src/hooks/useDictionary';
import PermissionsProvider from 'src/providers/PermissionsProvider';
import SecurityAdvisorContext from 'src/context/SecurityAdvisorContext';
import { Button, Table } from 'antd';
import { getEvents } from 'src/api/securityAdvisor';
import { notEmptyArray } from 'src/misc/Misc';
import EventViewer from 'src/components/pages/SecurityAdvisor/Components/Events/EventViewer';
import SkeletonTable from 'src/components/layout/SkeletonTable';
import { getEventListColumns } from 'src/components/pages/SecurityAdvisor/Misc/misc';
import { MdInfoOutline, MdPlayArrow } from 'react-icons/md';
import { Space, Tooltip, Card } from 'antd';
import EventFiltersCheckboxGroup from 'src/components/pages/SecurityAdvisor/Components/Events/EventFiltersCheckboxGroup';
import { optionsRole, optionsAuthUser } from 'src/components/pages/SecurityAdvisor/Misc/misc';
import { getDictionaryKey } from 'src/misc/Misc';

//import PropTypes from 'prop-types';

var eventsPageCurrentPage = 1;

const EventsFullWidget = () => {
  const { executeAsyncProcess, isBusy } = useAsyncProcesses();
  const actionDictionary = useDictionary('sa-events-action');
  const entityTypeDictionary = useDictionary('sa-events-entitytype');
  const { eventsFullWidgetReload, setEventsFullWidgetReload, eventsFullWidgetFiltersOpen, eventsFullWidgetFilters, setEventsFullWidgetFilters, getEventsFullWidgetFiltersCountLabel } = useContext(SecurityAdvisorContext);

  const [eventItems, setEventItems] = useState(null);
  const [pageSize, setPageSize] = useState(parseInt(50));
  const [thereIsMore, setThereIsMore] = useState(false);
  const [rerenderTable, setRerenderTable] = useState(false);
  const [clickedEvent, setClickedEvent] = useState(null);
  const [eventsFullWidgetFiltersModified, setEventsFullWidgetFiltersModified] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    eventsPageCurrentPage = 1;
    setRerenderTable(true);
    setEventItems(null);
    setThereIsMore(false);
    loadData();
  }, [pageSize]);

  useEffect(() => {
    if (eventsFullWidgetReload) {
      eventsPageCurrentPage = 1;
      setRerenderTable(true);
      setEventItems(null);
      setThereIsMore(false);
      setEventsFullWidgetReload(false);
      loadData();
    }
  }, [eventsFullWidgetReload]);

  useEffect(() => {
    setRerenderTable(true);
  }, [actionDictionary, entityTypeDictionary]);

  useEffect(() => {
    console.log('eventsFullWidgetFilters', eventsFullWidgetFilters);
  }, [eventsFullWidgetFilters]);

  useEffect(() => {
    if (rerenderTable) setRerenderTable(false);
  }, [rerenderTable]);

  const loadData = async (loadMore = false) => {
    await executeAsyncProcess(async () => {
      try {
        const filter = getEventsFullWidgetFiltersCountLabel() > 0 ? JSON.stringify(eventsFullWidgetFilters) : null;
        const resp = await getEvents(eventsPageCurrentPage, pageSize, filter);
        // const resp = await searchTenants(q?.length > 0 ? q : null, tenantsCurrentPage, pageSize);
        eventsPageCurrentPage++;
        setThereIsMore(resp?.length === pageSize ? true : false);
        if (true === notEmptyArray(resp)) {
          if (loadMore) setEventItems([...eventItems, ...resp]);
          else setEventItems(resp);
        } else {
          setEventItems([]);
        }
      } catch (error) {
        console.log(error);
      }
    });
  };

  const eventFilterOnChange = (entityType, checkedValues) => {
    const newFilters = { ...eventsFullWidgetFilters };
    newFilters[entityType] = checkedValues;
    setEventsFullWidgetFilters(newFilters);
    setEventsFullWidgetFiltersModified(true);
  };

  const btnApplyFiltersOnClick = () => {
    setEventsFullWidgetFiltersModified(false);
    eventsPageCurrentPage = 1;
    setRerenderTable(true);
    setEventItems(null);
    setThereIsMore(false);
    loadData();
  };

  return (
    <PermissionsProvider requiredPermissions={['apps.securityadvisor.view']}>
      {clickedEvent?.id && clickedEvent?.detail && <EventViewer eventId={clickedEvent.id} eventDetail={clickedEvent.detail} onClose={() => setClickedEvent(null)} />}

      {!eventItems ? (
        <SkeletonTable />
      ) : (
        <>
          {eventsFullWidgetFiltersOpen && (
            <Card className='mb-4'>
              <div className={'my-4 flex flex-row flex-wrap gap-4 justify-center'}>
                <Card
                  title={
                    <Space className='btn my-2 w-36'>
                      <div>{getDictionaryKey(entityTypeDictionary, 'Role')?.valueJson?.label ?? 'Role'}</div>
                      <Tooltip title={getDictionaryKey(entityTypeDictionary, 'Role')?.valueJson?.desc ?? 'no description'}>
                        <MdInfoOutline className='text-xs opacity-60' />
                      </Tooltip>
                    </Space>
                  }
                  size='small'
                >
                  <EventFiltersCheckboxGroup entityType='Role' options={optionsRole} value={eventsFullWidgetFilters?.Role ?? []} onChange={(checkedValues) => eventFilterOnChange('Role', checkedValues)} />
                </Card>
                <Card
                  title={
                    <Space className='btn my-2 w-36'>
                      <div>{getDictionaryKey(entityTypeDictionary, 'AuthUser')?.valueJson?.label ?? 'Role'}</div>
                      <Tooltip title={getDictionaryKey(entityTypeDictionary, 'AuthUser')?.valueJson?.desc ?? 'no description'}>
                        <MdInfoOutline className='text-xs opacity-60' />
                      </Tooltip>
                    </Space>
                  }
                  size='small'
                >
                  <EventFiltersCheckboxGroup entityType='AuthUser' options={optionsAuthUser} value={eventsFullWidgetFilters?.AuthUser ?? []} onChange={(checkedValues) => eventFilterOnChange('AuthUser', checkedValues)} />
                </Card>
              </div>
              <div className='text-center mt-4'>
                <Button type='primary' disabled={false === eventsFullWidgetFiltersModified} onClick={btnApplyFiltersOnClick}>
                  <Space className='btn'>
                    <MdPlayArrow />
                    Apply filters
                  </Space>
                </Button>
              </div>
            </Card>
          )}
          {!rerenderTable && (
            <Table
              loading={thereIsMore && isBusy}
              pagination={{
                onShowSizeChange: (current, size) => {
                  console.log('onShowSizeChange', current, size);
                  setPageSize(size);
                },
                showSizeChanger: true,
                pageSize,
                total: thereIsMore ? eventItems?.length + 1 : eventItems?.length ?? 0,
                onChange: (page, pageSize) => (thereIsMore && page > eventItems?.length / pageSize ? loadData(true) : null),
              }}
              rowKey={(record) => record.id}
              dataSource={eventItems}
              columns={getEventListColumns(actionDictionary, entityTypeDictionary)}
              size='small'
              onRow={(record) => ({
                onClick: () => {
                  setClickedEvent({ id: record.id, detail: record.detail });
                },
              })}
            />
          )}
        </>
      )}
    </PermissionsProvider>
  );
};

// Events.propTypes = {};

export default EventsFullWidget;
